import React from 'react';
import '../styles/Hero.css';

const Hero = () => {
  const scrollToProducts = () => {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero" id="home">
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge-top">
            <span className="trust-badge">
              <span className="trust-icon">⭐</span>


              <span className="trust-text">5/5 Rating</span>
            </span>
            <span className="trust-badge">
              <span className="trust-icon">👥</span>
              <span className="trust-text">5000+ Happy Customers</span>
            </span>
          </div>

          <h1 className="hero-title">
            Experience the Purity of Nature
          </h1>
          <p className="hero-subtitle">
            Premium Desi Ghee, Wild Honey, Shilajit & Natural Oils
          </p>
          <p className="hero-description">
            Sourced from the finest farms, delivered fresh to your doorstep. 100% organic, lab-tested, and certified pure.
          </p>

          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={scrollToProducts}>
              Shop Now
            </button>
            <a href="https://wa.me/923126108161" target="_blank" rel="noopener noreferrer" className="btn btn-outline">
              Order on WhatsApp
            </a>
          </div>

          <div className="hero-badges">
            <div className="badge">
              <div className="badge-icon">✓</div>
              <div className="badge-text">100% Pure</div>
            </div>
            <div className="badge">
              <div className="badge-icon">✓</div>
              <div className="badge-text">Lab Tested</div>
            </div>
            <div className="badge">
              <div className="badge-icon">✓</div>
              <div className="badge-text">Free Delivery</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;